import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import {
    collection,
    query,
    where,
    getDocs,
    deleteDoc,
    doc
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Save_log_history } from "../../log_history_root/save_log_history";
import { Toast } from '../../components_root/ToastContext';
import { MdArrowBackIos, MdClose, MdDeleteForever } from "react-icons/md";
 
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Delete_master() {

    const [tablename, setTablename] = useState("");
    const [filedname, setFiledname] = useState("");
    const [filedid, setFiledid] = useState("");
    const [description, setDescription] = useState("");
    const [history_type, setHistory_type] = useState("");
  
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [Enter_text, setEnter_text] = useState("");
  
       const servicetablename = "accountingfinancedb";
    useEffect(() => {
       
        const params = new URLSearchParams(window.location.search);
        const table = params.get("table");
        const filed = params.get("filed");
        const filedids = params.get("filedid");
        const descriptions = params.get("description");
        const historytypes = params.get("history_type");
        if (table) setTablename(table);
        if (filed) setFiledname(filed);
        if (filedids) setFiledid(filedids);
        if (descriptions) setDescription(descriptions);
        if (historytypes) setHistory_type(historytypes);
    }, [window.location.search]);

    const handle_delete = async () => {

        if (Enter_text !== "Delete") {
            Toastshow("Please type Delete to confirm");
            return;
        }

        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");

        if (!sessiontoken) return Toastshow("Session expired. Please relogin.");
        if (!guid) return Toastshow("Login expired. Please relogin.");
        if (!select_company_uid) return Toastshow("Contact service provider.");

        try {
            const collRef = collection(
                db,
                servicetablename,
                select_company_uid,
                tablename
            );

            const q = query(collRef, where(filedname, "==", filedid));
            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                Toastshow("No record found.");
                return;
            }

            for (const docSnap of snapshot.docs) {
                await deleteDoc(
                    doc(db, servicetablename, select_company_uid, tablename, docSnap.id)
                );

                Save_log_history({status:true, history_type, tablename, filedname, filedid, description: filedname + ", " + description })
            }

            Toastshow("Deleted successfully");
            navigate(-1);

        } catch (error) {
            Toastshow(error.message);
        }
    };

    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tr>
                        <td>
                            <div
                                onClick={() => navigate(-1)}
                                className="button-ui0 text-h2 bold p-2 cursor"
                            >
                                <MdArrowBackIos className="icon" />Delete Master
                            </div>
                        </td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/accounting")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div className="voucher-edit-body items-back b-1 rounded p-2">

                <table>
                    <tr>
                        <td><div className="text-h2 bold">Voucher name</div></td>
                    </tr>

                    <tr>
                        <td>
                            <div className="text-h2">
                                If you understand this action, delete this document permanently.
                                This action is not recoverable.
                                Enter <b className="bold">Delete</b> in the input below and click the Delete button.
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <input
                                className="p-2"
                                value={Enter_text}
                                onChange={(e) => setEnter_text(e.target.value)}
                                maxLength={30}
                                placeholder="Enter Delete"
                            />
                        </td>
                    </tr>
                </table>

                <br />

                <div
                    className="button-ui red-back p-22 fill text-h1 cursor"
                    onClick={handle_delete}
                >
                    <MdDeleteForever className="icon" />Delete
                </div>

            </div>
         
        </div>
    );
}
